import React, { useState } from 'react';
import FeedbackSurveySetup from './FeedbackSurveySetup';
import NotificationCreateForm from './NotificationCreateForm';
import NotificationList from './NotificationList';

const ManageNotificationsPage: React.FC = () => {
    const [listRefreshTrigger, setListRefreshTrigger] = useState(0);

    const handleCreated = () => {
        setListRefreshTrigger((prev) => prev + 1);
    };

    return (
        <div className="container max-w-7xl py-8 mx-auto">
            <div className="mb-8">
                <h1 className="text-2xl font-semibold tracking-tight">
                    Manage notifications
                </h1>
                <p className="text-muted-foreground">
                    Create notifications with title and message (rich text),
                    optional video or image, and choose which rights see them.
                </p>
            </div>

            <div className="mb-8">
                <FeedbackSurveySetup />
            </div>

            <div className="grid gap-8 lg:grid-cols-2 items-start">
                <NotificationCreateForm onCreated={handleCreated} />
                <NotificationList refreshTrigger={listRefreshTrigger} />
            </div>
        </div>
    );
};

export default ManageNotificationsPage;
